import gql from 'graphql-tag';

export default gql`
    mutation CreateAssetLoad($input: CreateAssetLoadInput) {
        createAssetLoad(input: $input) {
            errors
            loadIds
        }
    }
`;
